import React from 'react'
import { Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'

const Sponsor = ({ sponsor, classes, height, width }) => (
  <Box
    className={classes.sponsor}
    component={sponsor.link ? 'a' : 'div'}
    href={sponsor.link}
    target="new"
    style={{ backgroundImage: `url(${sponsor.image_url})`, height, width }}
  />
)

export default withStyles(styles, { withTheme: true })(Sponsor)



// WEBPACK FOOTER //
// ./src/components/Sponsors/Sponsor/index.jsx